import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { StorageService } from '../../../../services/system/storage.service';
import { ListingCategoryGroup } from '../../../../models/inModels/MarketPlaceModel';
import { ListingCategoryService } from '../../../../services/listing-categories/listing-category.service';

@Component({
  selector: 'app-create-category-group',
  templateUrl: './create-category-group.component.html',
})
export class CreateCategoryGroupComponent implements OnInit {
  model: ListingCategoryGroup;
  loading = false;
  error: Message[];
  messages: Message[];
  id: number;
  constructor(
    public storageService: StorageService,
    private router: Router,
    private route: ActivatedRoute,
    private service: ListingCategoryService) {
    this.model = new ListingCategoryGroup();
  }

  ngOnInit() {
    this.loading = true;
    this.id = this.route.snapshot.params.Id;
    this.service.get(this.id).then(
      res => {
        this.model = new ListingCategoryGroup(res);
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.messages = [];
        this.messages.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  goBack(): void {
    this.router.navigate(['/marketplace/listing-category/group']);
  }

  save() {
    this.loading = true;
    this.service.create(this.model).then(
      res => {
        this.model = new ListingCategoryGroup(res);
        this.loading = false;
        this.goBack();
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  handleIconImage(event): void {
    var result = this.storageService.handleSuccess(event);
    this.model.IconId = result.PublicId;
    this.loading = false;
  }

  handleDisplayImage(event): void {
    var result = this.storageService.handleSuccess(event);
    this.model.ImageId = result.PublicId;
    this.loading = false;
  }
    
  handleError(event): void {
    this.loading = false;
    this.error = [];
    this.storageService.handleError(event, this.error);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/listing-categories/create/create-group/create-category-group.component.ts